
export default function guest({next, router}) {
    console.log('guest');
    if (localStorage.getItem('id_token')){
        return router.push({name: 'dashboard'})
    }

    return next();
}